import { gqlClient } from '@/api/graphql-client';
import projectKeys from '@/api/queries/project/keyFactory';
import { graphql } from '@/gql';
import {
  SyncAllMaterialsFromLinkedEasyPvProjectMutation as _SyncAllMaterialsFromLinkedEasyPvProjectMutation,
  SyncAllMaterialsFromLinkedEasyPvProjectInput,
} from '@/gql/graphql';
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

const SyncAllMaterialsFromLinkedEasyPVProjectMutation = graphql(`
  mutation SyncAllMaterialsFromLinkedEasyPVProject(
    $input: SyncAllMaterialsFromLinkedEasyPVProjectInput!
  ) {
    syncAllMaterialsFromLinkedEasyPVProject(input: $input)
  }
`);

const useSyncAllMaterialsFromLinkedEasyPVProject = (args?: {
  projectId?: string;
  options?: UseMutationOptions<
    _SyncAllMaterialsFromLinkedEasyPvProjectMutation,
    unknown,
    SyncAllMaterialsFromLinkedEasyPvProjectInput
  >;
}) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = args?.options ?? {};
  return useMutation({
    mutationFn: (input: SyncAllMaterialsFromLinkedEasyPvProjectInput) => {
      return gqlClient.request(
        SyncAllMaterialsFromLinkedEasyPVProjectMutation,
        {
          input,
        }
      );
    },
    onSuccess: (data, variables, context) => {
      if (args?.projectId) {
        void queryClient.invalidateQueries({
          queryKey: projectKeys.integrations(args.projectId),
        });
      }
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useSyncAllMaterialsFromLinkedEasyPVProject;
